module.exports = __webpack_public_path__ + "img/footerbackground.cf36fc32.webp";